import {combineReducers} from "redux";

import user from "./user";
import planDemand from "./planDemand";
import cases from "./cases";
import chatCase from "./chatCase";
import modal from "./modal";
import sheets from "./sheets";
import apiFlag from "./apiFlag";
import stripePayment from "./stripePayment";
import freeQuestionChatBot from "./freeQuestionChatBot";
import questionsAndAnswers from "./questionsAndAnswers";
import sheetsvideosformations from "./sheetsvideosformations";
import navLink from "./navLink";
import posts from "./posts";
// Placer les différents reducer à utiliser
export default combineReducers({
    user,
    planDemand,
    cases,
    chatCase,
    modal,
    sheets,
    posts,
    apiFlag,
    stripePayment,
    freeQuestionChatBot,
    questionsAndAnswers,
    sheetsvideosformations,
    navLink
});